import { Box } from '@mui/material'
import React from 'react'
import type { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Select from '@/components/Select'
import {
  FORM_FIELDS,
  type FormData,
} from '@/pages/getRecipe/allInOne/utils/formTypes'
import { updateAllInOneFormValue } from '@/store/allInOne'
import { REGION } from '@/utils/constants'

import { COLOR_VALUE } from '../../utils/constants'

interface ColorSelectsProps {
  control: Control<FormData>
  prefix: string
  selectedColor: string
  currentOptions: any[]
  isTripleDentin: boolean
  dispatch: any
}

const ColorSelects: React.FC<ColorSelectsProps> = ({
  control,
  prefix,
  selectedColor,
  currentOptions,
  isTripleDentin,
  dispatch,
}) => {
  const { t } = useTranslation()
  if (
    !selectedColor ||
    selectedColor === COLOR_VALUE.LabColor ||
    !currentOptions?.length
  ) {
    return null
  }

  if (isTripleDentin) {
    return (
      <Box display="flex" gap={1} alignItems="start">
        <Select
          options={currentOptions}
          title={t(REGION.CERVICAL)}
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_CERVICAL
              : FORM_FIELDS.TARGETCERVICAL
          }
          titleSize="small"
          onFormValueChange={(name, value) =>
            dispatch(updateAllInOneFormValue({ name, value }))
          }
          placeholder={currentOptions[0]?.text}
          sx={{ width: '92.33px' }}
        />
        <Select
          options={currentOptions}
          title={t(REGION.MIDDLE)}
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_MIDDLE
              : FORM_FIELDS.TARGETMIDDLE
          }
          titleSize="small"
          onFormValueChange={(name, value) =>
            dispatch(updateAllInOneFormValue({ name, value }))
          }
          placeholder={currentOptions[0]?.text}
          sx={{ width: '92.33px' }}
        />
        <Select
          options={currentOptions}
          title={t(REGION.INCISAL)}
          control={control}
          name={
            prefix === 'prep'
              ? FORM_FIELDS.PREPCOLOR_INCISAL
              : FORM_FIELDS.TARGETINCISAL
          }
          titleSize="small"
          onFormValueChange={(name, value) =>
            dispatch(updateAllInOneFormValue({ name, value }))
          }
          placeholder={currentOptions[0]?.text}
          sx={{ width: '92.33px' }}
        />
      </Box>
    )
  }

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Select
        options={currentOptions}
        title={t(REGION.MIDDLE)}
        control={control}
        name={
          prefix === 'prep'
            ? FORM_FIELDS.PREPCOLOR_MIDDLE
            : FORM_FIELDS.TARGETMIDDLE
        }
        titleSize="medium"
        onFormValueChange={(name, value) =>
          dispatch(updateAllInOneFormValue({ name, value }))
        }
        placeholder={currentOptions[0]?.text}
      />
    </Box>
  )
}

export default ColorSelects
